<div>
    <h1>Users</h1>
    @if (client$ | async; as client) {
        @if (client.is_paid && !hosted) {
            <div>
                <span>{{ client.paid_members }} / {{ client.member_quota }}</span>
                <mat-progress-bar
                    mode="determinate"
                    [value]="(client.paid_members / client.member_quota) * 100"
                ></mat-progress-bar>
            </div>
        }
    }
</div>

<mat-form-field>
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" #input />
</mat-form-field>

<div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
            <td mat-cell *matCellDef="let row" [class.owner]="row.is_owner">
                <img src="{{ row.avatar || (row.email | identicon | async) }}" class="user-icon" />
            </td>
        </ng-container>

        <ng-container matColumnDef="role">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
            <td mat-cell *matCellDef="let row" [class.owner]="row.is_owner">
                <mat-icon [matTooltip]="RoleMapping[row.role]?.tooltip">{{
                    RoleMapping[row.role]?.icon
                }}</mat-icon>
            </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let row" [class.owner]="row.is_owner">
                {{ row.email }}
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let row" [class.owner]="row.is_owner">
                {{ row.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="last_login">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Login</th>
            <td mat-cell *matCellDef="let row" [class.owner]="row.is_owner">
                {{ row.last_login | date }}
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let row" [class.owner]="row.is_owner">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                    <mat-icon>more_horiz</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="userDetail(row)">Edit Details</button>
                    <button mat-menu-item (click)="assignRole(row)">Assign Role</button>
                    <mat-divider></mat-divider>
                    <button mat-menu-item (click)="removeUser(row)">Remove</button>
                </mat-menu>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data matching the filter "{{ input.value }}"</td>
        </tr>
    </table>
</div>
